import Fetch from '../../../../utils/fetch';
import { settings } from '../../../../settings';
import { useCallback, useEffect, useState } from 'react';

export type DeviationType =
  | 'NOT_HOME'
  | 'CANT_FIND_ADDRESS'
  | 'NOT_IN_CAR'
  | 'DAMAGED'
  | 'OTHER';

export type DeviationEventType = 'OPEN' | 'CHANGE' | 'CLOSE';

export type DeviationVisibility = 'INTERNAL' | 'EXTERNAL';

export type DeviationEvent = {
  id: number;
  createdAt: string;
  parentEventId: number | null;
  deviationType: DeviationType;
  deviationVisibilities: DeviationVisibility[];
  deviationEventType: DeviationEventType;
  message?: string;
  legId: number;
  authorName: string;
  authorRole: string;
};

export type DeviationGroups = Record<number, DeviationEvent[]>;

export type DeviationSummary = {
  parentEventId: number;
  parentDeviationType: DeviationType;
  parentDeviationVisibilities: DeviationVisibility[];
  isOpen: boolean;
  updateLines: UpdateLine[];
};

type UpdateLine = {
  createdAt: string;
  message: string;
};

async function orderAPIFetchDeviations(
  orderId: string
): Promise<DeviationGroups | undefined> {
  try {
    const response = await Fetch.get({
      url: `${settings.newApiUrl}/deviation/v2/${orderId}/grouped`,
    });
    //TODO: Error
    if (!response.ok) {
      return {};
    }
    return response.json();
  } catch (e) {
    console.log('Error fetching deviations info', e);
    return {};
  }
}

export async function fetchDeviationSummaries(
  orderIds: string[]
): Promise<Map<string, DeviationSummary[] | undefined>> {
  if (orderIds.length === 0) {
    return new Map();
  }
  const orderIdsParam = orderIds.join(',');
  const response = await Fetch.get({
    url: `${settings.newApiUrl}/deviation/v2/grouped?orderIds=${orderIdsParam}`,
  });
  if (response.ok) {
    const data = await response.json();
    return new Map(Object.entries(data));
  } else {
    return new Map();
  }
}

export const useDeviations = (orderId: string) => {
  const [deviations, setDeviations] = useState<DeviationGroups>({});

  const fetchDeviations = useCallback(() => {
    orderAPIFetchDeviations(orderId)
      .then(setDeviations)
      .catch(e => console.error(e));
  }, [orderId]);
  useEffect(() => {
    fetchDeviations();
  }, [fetchDeviations]);
  return { deviations, refetchDeviations: fetchDeviations };
};
